import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { alert } from 'actions/flash'
import { useUpdateMerchantMutation } from 'api/merchants'
import { isError } from 'api/utils'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import { setFormSubmitting } from 'slices/Cms/Settings/ScannableCodes'
import {
  selectApiFormattedFormData,
  selectFormDisabled,
  selectIsFormSubmitting,
} from 'slices/Cms/Settings/ScannableCodes/selectors'

const t = buildTranslate('cms.settings.scannable_codes')

export const useScannableCodesSubmitForm = () => {
  const dispatch = useDispatch()
  const apiFormattedFormData = useSelector(selectApiFormattedFormData)
  const formDisabled = useSelector(selectFormDisabled)
  const isFormSubmitting = useSelector(selectIsFormSubmitting)
  const [updateMerchant] = useUpdateMerchantMutation()

  const handleSubmit = useCallback(async () => {
    if (formDisabled || isFormSubmitting) return

    dispatch(setFormSubmitting(true))
    const result = await updateMerchant({
      data: apiFormattedFormData,
    })
    dispatch(setFormSubmitting(false))

    if (isError(result)) {
      dispatch(
        alert({
          key: 'danger',
          message: t('alert.submit_error'),
          timeout: 5,
        })
      )
      return
    }

    dispatch(
      alert({
        key: 'success',
        message: t('alert.submit_success'),
        timeout: 5,
      })
    )
  }, [
    apiFormattedFormData,
    updateMerchant,
    dispatch,
    formDisabled,
    isFormSubmitting,
  ])

  return handleSubmit
}
